import * as _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import ReceiptDocs from './ReceiptDocs';
// import Voucher from 'src/models/AP/VoucherMaintenanceForm';
import { ExpenseType } from 'src/models/AP/ExpenseType';
// import Expense from 'src/models/AP/Expense';
import CreditCardRecForm from 'src/models/AP/CreditCardRecForm';
import moment from 'moment';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';
import VoucherToPay from 'src/models/AP/VoucherToPay';
import FindPersonDialog from '../dialogs/FindPersonDialog';
import DefineBudgetCategoryDialog from '../dialogs/DefineBudgetCategoryDialog';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import WarningDialog from '../dialogs/WarningDialog';
// icons
import { BiReceipt, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaLock, FaLockOpen, FaPrint, FaRegSave } from 'react-icons/fa';
// import { FaRegFileExcel } from 'react-icons/fa';
import { GiQuillInk } from 'react-icons/gi';
import { FaMoneyCheckAlt, FaCreditCard } from 'react-icons/fa';
// import { MdDoNotDisturb } from 'react-icons/md';
import { VscGraph } from 'react-icons/vsc';
import ReportOptionsDialog from '../dialogs/ReportOptionsDialog';
import ChooseVouchersDialog from '../dialogs/ChooseVouchersDialog';
import CreditCardTransaction from 'src/models/AP/CreditCardTransaction';
import CreditCardTransactionDetail from 'src/models/AP/CreditCardTransactionDetail';
import AccountInfo from 'src/models/AP/AccountInfo';
import CreditCardType from 'src/models/AP/CreditCardType';
// import { SelectItem } from 'src/models/common/SelectItem';
import VoucherReceipt from 'src/models/AP/VoucherReceipts';
import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
import Account from 'src/models/Account';
import TSDIEmployeesDialog from '../dialogs/TSDIEmployeesDialog';
import Employee from 'src/models/AP/Employee';
import CreditCardStatementDialog from '../dialogs/CreditCardStatementDialog';
import LoadRawDataFileDialog from '../dialogs/LoadRawDataFileDialog';
import EnterCheckNumberDialog from '../dialogs/EnterCheckNumberDialog';
import CreateCheckWarningDialog from '../dialogs/CreateCheckWarningDialog';
import OutputDestinationDialog from '../dialogs/OutputDestinationDialog';
import APNavBar from '../APNavBar';
import CreditCardSearch, { ICreditCardTransactionSearchCriteria } from '../components/CreditCardSearch';
import GLAccountSelect from '../components/GLAccountSelect';
import PersonnelToast from 'src/components/personnel/components/PersonnelToast';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';

const CreditCardsRecPage = () => {
    const dispatch = useDispatch();
    const { get, post, del, put, response } = useFetch();
    const { get: getBinary, response: responseBinary } = useFetch('/v1.0', {
        responseType: 'arrayBuffer' // only applies to this instance
    });
    const { register, reset, handleSubmit, errors, setValue, getValues, formState } = useForm();
    const { isDirty, dirtyFields } = formState;
    // const [selectedEmployeePay, setSelectedEmployeePay] = useState(undefined);
    const [chargeIndividuals, setChargeIndividuals] = useState<Array<ChargeIndividual>>([]); // The whole personnel list
    const [allChargeIndividuals, setAllChargeIndividuals] = useState<Array<ChargeIndividual>>(undefined);
    const [expenses, setExpenses] = useState<CreditCardTransactionDetail[]>(undefined);
    const [selectedExpense, setSelectedExpense] = useState<CreditCardTransactionDetail>(undefined);
    const [selectedExpenseIndex, setSelectedExpenseIndex] = useState<number>(undefined);
    const [selectedIndividualIndex, setSelectedIndividualIndex] = useState<number>(-1);
    const [selectedCreditCardTransactionIndex, setSelectedCreditCardTransactionIndex] = useState<number>(0);
    const [creditCardTransactions, setCreditCardTransactions] = useState<Array<CreditCardTransaction>>(undefined);
    const [creditCardTypes, setCreditCardTypes] = useState<Array<CreditCardType>>([]);
    const [billingAccounts, setBillingAccounts] = useState<{ code: number, description: string}[]>([]);
    const [officeExpenseCodes, setOfficeExpenseCodes] = useState<{ code: number, description: string}[]>([]);
    const [budgetCategories, setBudgetCategories] = useState<{ id: number, name: string }[]>([]);
    const [budgetSubcategories, setBudgetSubcategories] = useState<{ id: number, categoryId: number, name: string }[]>([]);
    // const [creditCardTypesList, setCreditCardTypesList] = useState<Array<SelectItem>>([]);
    const [creditCardTransactionDetail, setCreditCardTransactionDetail] = useState<Array<CreditCardTransactionDetail>>(undefined);
    const [loadingCreditCardTransactionDetail, setLoadingCreditCardTransactionDetail] = useState<boolean>(false);
    const [searchingCreditCardTransactions, setSearchingCreditCardTransactions] = useState<boolean>(false);
    const [noTransactionsFound, setNoTransactionsFound] = useState<boolean>(false);
    const [recordNumberInput, setRecordNumberInput] = useState<string>('');
    const [recordNumberError, setRecordNumberError] = useState<string>('');
    const [, setUnsavedTransactionDetails] = useState<boolean>(false);
    const [toast, setToast] = useState<{ message: string; color?: string; persistent?: boolean; } | null>(null);
    // Keyed by detail row id. GLAccountSelect's hidden input reports its selection through RHF's
    // setValue for isDirty bookkeeping, but that doesn't reliably come back out of getValues() at
    // submit time - this is the value onSubmit actually uses when building the save payload.
    const [editedGlAccountNumbers, setEditedGlAccountNumbers] = useState<Record<number, string>>({});
    // Keyed by detail row id. Tracks the Budget Category select's current value per row purely so
    // the Subcategory select's option list can be filtered/re-rendered as the user changes category
    // (the actual saved value is the subcategory's own bcdId, read normally through the form).
    const [selectedBudgetCategoryByRow, setSelectedBudgetCategoryByRow] = useState<Record<number, string>>({});
    const [creditCardTransactionAccountInfo, setCreditCardTransactionAccountInfo] = useState<AccountInfo>(undefined);
    const [creditCardReceipts, setCreditCardReceipts] = useState<Array<VoucherReceipt>>(undefined);
    const [fileToUpload, setFileToUpload] = useState<FormData>(undefined);
    const creditCardRecForm: CreditCardRecForm = {  
        ccId: 1, 
        ccName: 'Credit Card Name', 
        closeDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date, 
        ccTransactionNumber: 2128, 
        invoiceDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date, 
        invoiceAmount: 22.64,
        checkNumber: 3, 
        checkDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
        creditCardDetails: [
            {
                id: 1, 
                transactionItemId: 1,
                chargeDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
                chargeAmount: 1024.64, 
                chargedById: 1034, 
                chargedByName: 'Brendan Bryan', 
                description: 'Coffee', 
                statementDescription: 'Starbucks', 
                glAccountNumber: '2-5-07-115-0000-8',
                clientNumber: 1,
                projectNumber: 1,
                sectionNumber: 1,
                unitNumber: null,
                billingAccount: 'Lease Acqusition', 
                expenseCode: ExpenseType.Shipping_Expense, 
                budgetCategoryName: 'category', 
                budgetSubcategoryName: 'subcategory'
            },
        ], 
        chargeIndividual: [
            {
                id: 1,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 2,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 3,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
        ], 
        accountInfo: {
            id: 2,
            client: 'Dudley Land Company',
            clientName: 'Dudley Land Company',
            clientNumber: 1,
            project: 'Oklahoma Office',
            projectName: 'Oklahoma Office',
            projectNumber: 1,
            prospect: null,
            sectionNumber: 3,
            sectionName: '',
            unitNumber: null,
            unitName: '',
            billingAccount: 'Lease Acquisition',
            glAccount: '2-5-07-115-0000-8',
        }
    };

    const formatDateForInput = (date: Date | string | null | undefined) => {
        const m = moment(date);
        return m.isValid() ? m.format('YYYY-MM-DD') : '';
    };

    const NO_TRANSACTIONS_FOUND_MESSAGE = 'No Transactions match the current search criteria';

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        getBillingAccounts();
        getOfficeExpenseCodes();
        getBudgetCategories();
        getBudgetSubcategories();
        getCreditCardTypes();
        getCreditCardTransactions();
        getChargeIndividuals('100'); // hard-coded for now until it is determined how to retrieve this list in this context.
        return () => {
            onDestroy();
        };
    }, []);

/*     useEffect(() => {
        if (!!creditCardTypes) {
            setCreditCardTypesList(getCreditCardTypeDropDownOptionList());
        }
    }, [creditCardTypes]); */

    useEffect(() => {
        if (!!fileToUpload) {
            prepareCsvFileForUpload(fileToUpload);
        }
    }, [fileToUpload]);

    useEffect(() => {
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > 0) {
            let initForm = (!!creditCardTransactions && creditCardTransactions.length > 0) ? creditCardTransactions[selectedCreditCardTransactionIndex] : new CreditCardTransaction();
            if (!initForm) {
                return;
            }
            initForm.creditCardTransactionDetail = [...creditCardTransactionDetail];
            const creditCardTypeName = creditCardTypes?.find(c => `${c.id}` === `${initForm.creditCardType}`)?.name
                ?? (!!initForm.creditCardType ? `${initForm.creditCardType}` : '');
            reset({
                ...initializeData(initForm),
                creditCardTypeName,
                checkDate: formatDateForInput(initForm.checkDate),
                closeDate: formatDateForInput(initForm.closeDate),
                invoiceDate: formatDateForInput(initForm.invoiceDate),
            });
            calculateTotal();
            setUnsavedTransactionDetails(false);
            setEditedGlAccountNumbers({});
            setSelectedBudgetCategoryByRow({});
        }
    }, [creditCardTransactionDetail]);

    useEffect(() => {
        if (!!creditCardTransactions) {
            getCreditCardTransactionDetails(creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber);
            getCreditCardTransactionAccountInfo(creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber);
        }
    }, [creditCardTransactions]);

    // SelectedEmployeePay changes on Update Pay
/*     useEffect(() => {
        console.log('resetting the form');
        reset(initializeData(selectedEmployeePay));
    }, [selectedEmployeePay]); */

/*     useEffect(() => {
        console.log('Employee Pay Exceptions', creditCardRecForm);
    }, [creditCardRecForm]); */

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('CreditCardsRecPage onCreate()');
        // getPersonnelEmployeePay();
        setExpenses(creditCardRecForm?.creditCardDetails);
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('CreditCardsRecPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    // A fresh object per request (rather than the DialogList value itself) so requesting the
    // SAME dialog twice in a row still trips the effect below - useState bails out on an
    // Object.is-equal value, and a repeated enum value would go stale.
    const [pendingDialogToShow, setPendingDialogToShow] = useState<{ dialog: DialogList } | null>(null);

    // hideDialog() immediately followed by showDialog() in the same tick doesn't reliably swap
    // dialogs - defer the "show" to its own effect/render cycle instead of chaining it directly.
    // This coordination has to live at the page level (not inside a dialog component): once a
    // dialog's own isOpen goes false, unmountOnExit tears down everything nested inside it,
    // including any state/effects a child dialog owned - so a dialog can't reliably launch
    // another dialog on its own.
    useEffect(() => {
        if (pendingDialogToShow) {
            showDialog(pendingDialogToShow.dialog);
            setPendingDialogToShow(null);
        }
    }, [pendingDialogToShow]);

    // Statement Maintenance reacts to this (via its refreshToken prop) to reload its statement
    // list/transaction lines and show a success toast after a raw file uploads successfully.
    const [statementListRefreshToken, setStatementListRefreshToken] = useState<{} | null>(null);

    const showLoadRawDataFileForStatement = () => {
        hideDialog(DialogList.LOAD_RAW_DATA_FILE_FOR_STATEMENT);
    };

    const handleStatementFileUploaded = () => {
        showDialog(DialogList.CREDIT_CARD_STATEMENT_MAINTENANCE);
        setStatementListRefreshToken({});
    };

    const getChargeIndividualsForSelectedCcTransaction = (transactionIndex: number) => {
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > transactionIndex) {
            setSelectedCreditCardTransactionIndex(transactionIndex);
            const transactionDetailId = creditCardTransactionDetail[transactionIndex].transactionItemId;
            getChargeIndividuals(transactionDetailId.toString());
            getCreditCardReceipts(transactionDetailId.toString());
        }
    };

    const getCreditCardReceipts = async (ccTransactionId: string) => {
        let result = await get(`/v1.0/AccountsPayable/receipts/creditcards/${ccTransactionId}`);

        if (response.ok) {
            setCreditCardReceipts(result?.items);
        } else {
            console.log('Unable to get credit card receipt Data!');
        }
    };

    const getCreditCardTransactions = async () => {
        let result = await get(`/v1.0/AccountsPayable/creditcards/transactions`);

        if (response.ok) {
            setCreditCardTransactions(result?.items);
        } else {
            setCreditCardTransactions([]);
            console.log('Unable to get CC transaction Data!');
        }
    };

    const getChargeIndividuals = async (ccTransactionId: string) => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals/creditcard/transaction/${ccTransactionId}`);

        if (response.ok) {
            setChargeIndividuals([]);
            setChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get charge individuals Data!');
        }
    };

    const removeChargeIndividual = async (payload: ChargeIndividual) => {
        let result = await del(`/v1.0/AccountsPayable/chargeindividual?voucherAccountId=${payload?.voucherAccountId}&ccTransactionId=${payload?.creditCardDetailId}&personType=${payload.personType}&clientNumber=${payload.clientNumber}&lmNumber=${payload.lmNo}`);

        if (response.ok) {
            getChargeIndividuals(payload.creditCardDetailId.toString());
        } else {
            console.log('Unable to delete charge individual!' + result);
        }
    };

/*     const getCreditCardTypeDropDownOptionList = () => {
        let ccTypeList: SelectItem[] =
        creditCardTypes.map(cct => {
            return { id: cct.id, name: cct.name };
            });
        return ccTypeList;
    }; */

    const handleConfirmRemovePerson = () => {
        removeSelectedPerson(selectedIndividualIndex);
    };

    const removeSelectedPerson = async (index: number) => {
        let selectedChargeIndividual = chargeIndividuals[index];
        selectedChargeIndividual.creditCardDetailId = creditCardTransactionDetail[selectedCreditCardTransactionIndex].transactionItemId;
        await removeChargeIndividual(selectedChargeIndividual);
/*         let temp = chargeIndividuals.slice();

        if (temp.length > 0 && index >= 0) {
            temp.splice(index, 1);
            setChargeIndividuals(temp);
        }

        setSelectedIndividualIndex(-1); */
    };

    const getCreditCardTypes = async () => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/creditcards/types`);

        if (response.ok) {
            setCreditCardTypes(result?.items);
        } else {
            setCreditCardTypes([]);
            console.log('Unable to get CC type Data!');
        }
    };

    const getCreditCardTransactionDetails = async (transactionId: number) => {
        setLoadingCreditCardTransactionDetail(true);
        const pagingOptions = new ODataOptions();
        pagingOptions.addPaging(1, 50);
        let result = await get(`/v1.0/AccountsPayable/creditcards/transactiondetails/${transactionId}${pagingOptions.toString()}`);

        if (response.ok && result?.items?.length) {
            setCreditCardTransactionDetail([]);
            setCreditCardTransactionDetail(result?.items);
        } else {
            setCreditCardTransactionDetail([{
                id: -1,
                transactionItemId: 0,
                chargeDate: new Date(),
                chargeAmount: 0,
                chargedByName: '',    
                chargedById: 0,
                description: '',
                statementDescription: '',
                clientNumber: 90,
                projectNumber: 1,
                billingAccount: '1',
                expenseCode: 'O',
                glAccountNumber: '',
                sectionNumber: 0,
                unitNumber: 0,
                budgetCategoryName: '',
                budgetSubcategoryName: ''}]);
            console.log('Unable to get credit card transaction detail data!');
        }
        setLoadingCreditCardTransactionDetail(false);
    };

    const getCreditCardTransactionAccountInfo = async (transactionId: number) => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/creditcards/transaction/${transactionId}`);

        if (response.ok) {
            setCreditCardTransactionAccountInfo(result);
        } else {
            setCreditCardTransactionAccountInfo(undefined);
            console.log('Unable to get CC Acount Info Data!');
        }
    };

    const calculateTotal = () => {
        let total = 0;
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > 0) {
            creditCardTransactionDetail?.map((ccd) =>
                total += ccd.chargeAmount
            );
        }
        return total;
    };

    const handleSelectedVouchers = (vouchers: VoucherToPay[]) => {
        console.log(vouchers);
    };

    // nextDialog is optional - passing one queues that dialog to show once this one has actually
    // finished hiding (see the pendingDialogToShow effect above), rather than calling showDialog()
    // directly in the same tick as hideDialog().
    const hideDialog = (nextDialog?: DialogList) => {
        dispatch(actions.layout.hideDialog());
        if (nextDialog) {
            setPendingDialogToShow({ dialog: nextDialog });
        }
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, color, persistent });
    };

    const initializeData = (data: CreditCardTransaction) => {
        let newData: CreditCardTransaction = { ...data };

        return newData;
    };

    const addChargeIndividual = async (payload: ChargeIndividual) => {
        let result = await post(`/v1.0/AccountsPayable/chargeindividual/create`, payload);

        if (response.ok) {
            getChargeIndividuals(payload.creditCardDetailId.toString());
        } else {
            console.log('Unable to add charge individual!' + result);
        }
    };

    const addCreditCardTransactionDetail = async (payload: CreditCardTransactionDetail): Promise<boolean> => {
        await post(`/v1.0/AccountsPayable/creditcard/transactiondetail/create`, payload);
        return response.ok;
    };

    const addCreditCardTransaction = async (payload: CreditCardTransaction): Promise<boolean> => {
        await post(`/v1.0/AccountsPayable/creditcard/transaction/create`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        }
        return response.ok;
    };

    const updateCreditCardRecord = async (payload: CreditCardTransaction): Promise<boolean> => {
        await put(`/v1.0/AccountsPayable/creditcard/transaction`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        }
        return response.ok;
    };

    const updateCreditCardTransactionDetail = async (payload: CreditCardTransactionDetail): Promise<boolean> => {
        await put(`/v1.0/AccountsPayable/creditcard/transactiondetail`, payload);
        return response.ok;
    };

    const handleSelectedPerson = async (person: ChargeIndividual) => {
        const transactionDetailId = creditCardTransactionDetail[selectedCreditCardTransactionIndex].transactionItemId;
        person.creditCardDetailId = transactionDetailId;
        await addChargeIndividual(person);
        /* let chargeIndividualsList: ChargeIndividual[] = [];

        let chargeIndividual: ChargeIndividual = {
            id: person.id,
            personType: person.personType,
            clientNumber: null,
            clientCity: null,
            clientState: null,
            clientName: null,
            lmNo: person.id,
            firstName: person.firstName,
            lastName: person.lastName,
            voucherAccountId: null,
            creditCardDetailId: null
        };

        chargeIndividuals?.forEach(c => {
            chargeIndividualsList?.push(c);
        });

        chargeIndividualsList?.push(chargeIndividual);

        setChargeIndividuals(chargeIndividualsList); */
    };

    const handleDownload = () => {
        console.log('Download Clicked');
    };

    const handleReport = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
    };

    const handleSelectedAccount = (account: Account) => {
        console.log(account);

        selectedExpense.glAccountNumber = account.accountNumber;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
    };

    const handleSelectedEmployee = (employee: Employee) => {
        console.log();

        selectedExpense.chargedById = employee.tsdNo;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
    };

    const handleCategories = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
        selectedExpense.budgetCategoryName = category;
        selectedExpense.budgetSubcategoryName = subcategory;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
        // setSelectedExpense(modifiedExpense);
    };

    const handleConfirmCreateCheck = () => {
        console.log('Create Check confirmed');
    };

    const displayWarning = (index: number) => {
        setSelectedIndividualIndex(index);
        dispatch(actions.layout.showDialog(DialogList.WARNING));
    };

    const findTsdiEmployee = (expense: CreditCardTransactionDetail, index: number) => {
        setSelectedExpense(expense);
        setSelectedExpenseIndex(index);
        dispatch(actions.layout.showDialog(DialogList.TSDI_EMPLOYEES));
    };

    const accessCreditCardStatement = () => {
        dispatch(actions.layout.showDialog(DialogList.CREDIT_CARD_STATEMENT_MAINTENANCE));
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const chooseVouchers = () => {
        showDialog(DialogList.CHOOSE_VOUCHERS_TO_PAY);
    };

    const writeCheck = () => {
        showDialog(DialogList.ENTER_CHECK_NUMBER);
    };

/*     const removeSelectedPerson = (index: number) => {
        let temp = chargeIndividuals.slice();

        if (temp.length > 0 && index >= 0) {
            temp.splice(index, 1);
            setChargeIndividuals(temp);
        }

        setSelectedIndividualIndex(-1);
    }; */

    const isMainTransactionModified = () => {
        if (!!dirtyFields.creditCardType || !!dirtyFields.checkDate || !!dirtyFields.checkNumber || !! dirtyFields.closeDate ||
            !!dirtyFields.invoiceDate || !!dirtyFields.invoiceAmount) {
            return true;
        }
        return false;
    };

    const onSubmit = async (data: CreditCardRecForm) => {
        if (!data) {
            return;
        }

        const formData = getValues();
        const transactionId = Number(formData.transactionNumber);

        if (isDirty && isMainTransactionModified()) {
            let newCreditCardTransaction = new CreditCardTransaction();
            newCreditCardTransaction.checkDate = null;
            newCreditCardTransaction.checkNumber = Number(formData.checkNumber);
            newCreditCardTransaction.creditCardType = formData.creditCardType;
            newCreditCardTransaction.closeDate = null;
            newCreditCardTransaction.invoiceDate = new Date();
            newCreditCardTransaction.invoiceAmount = Number(formData.invoiceAmount);

            if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > 0) {
                newCreditCardTransaction.creditCardTransactionDetail = [...creditCardTransactionDetail];
            }

            const success = isNaN(transactionId)
                ? await addCreditCardTransaction(newCreditCardTransaction)
                : await updateCreditCardRecord(newCreditCardTransaction);

            showToast(
                success ? 'Credit card transaction saved successfully.' : 'Unable to save credit card transaction.',
                success ? undefined : `rgba(255,0,0,0.5)`
            );
            return;
        }

        if (!creditCardTransactionDetail || creditCardTransactionDetail.length === 0) {
            return;
        }

        // A row is saved if the user actually changed one of its fields (per-row isDirty), or if
        // it's a brand-new row added via insertBlankRow (negative id) - those aren't part of the
        // form's reset() defaultValues yet, so RHF's dirty tracking on them can't be relied on.
        const detailDirtyFields = dirtyFields?.creditCardRecForm?.creditCardDetails;
        let anySaved = false;
        let anyFailed = false;

        for (let ccDetailsIndex = 0; ccDetailsIndex < creditCardTransactionDetail.length; ccDetailsIndex++) {
            const detailRow = creditCardTransactionDetail[ccDetailsIndex];
            const isNewRow = detailRow.id < 0;
            const editedGlAccountNumber = editedGlAccountNumbers[detailRow.id];
            const isRowDirty = !!detailDirtyFields?.[ccDetailsIndex] || editedGlAccountNumber !== undefined;

            if (!isNewRow && !isRowDirty) {
                continue;
            }

            const formRow = formData.creditCardRecForm.creditCardDetails[ccDetailsIndex];
            // formRow's keys are whatever each row's RHFInputBox/RHFSelect was registered under,
            // which don't all match CreditCardTransactionDetail's property names 1:1 (e.g. the
            // "chargedBy"/"employeeName"/"expenseType" inputs feed chargedById/chargedByName/
            // expenseCode), and client/project/section/unit number aren't registered at all - those
            // cells are read-only display text, so they only ever exist on detailRow (state).
            // Numeric inputs are uncontrolled text/number fields under plain register(), so their
            // form values are raw strings - Number(...) here is what keeps the JSON payload sending
            // actual numbers instead of quoted strings the C# decimal/int properties can't parse.
            const creditCardDetailPayload = {
                chargeDate: formRow.chargeDate,
                // AddCreditCardTransactionDetail binds this to CC_ID (the master transaction to
                // attach a new row to), while UpdateCreditCardTransactionDetail binds it to CCD_ID
                // (the row's own key) - same field name, different meaning per endpoint.
                transactionItemId: isNewRow ? transactionId : detailRow.transactionItemId,
                chargeAmount: Number(formRow.chargeAmount) || 0,
                chargedById: Number(formRow.chargedBy) || 0,
                chargedByName: formRow.employeeName,
                description: formRow.description,
                statementDescription: formRow.statementDescription,
                // formRow.glAccountNumber comes back from RHF's getValues() on a hidden/uncontrolled
                // input and isn't reliable - editedGlAccountNumber is what GLAccountSelect's own
                // onAccountNumberChange callback reported, which is what actually reflects a selection.
                glAccountNumber: editedGlAccountNumber ?? detailRow.glAccountNumber,
                clientNumber: detailRow.clientNumber,
                projectNumber: detailRow.projectNumber,
                sectionNumber: detailRow.sectionNumber,
                unitNumber: detailRow.unitNumber,
                billingAccount: formRow.billingAccount,
                expenseCode: formRow.expenseType,
                id: isNewRow ? 0 : detailRow.id,
                bcdId: formRow.bcdId ? Number(formRow.bcdId) : null,
            };

            const success = isNewRow
                ? await addCreditCardTransactionDetail(creditCardDetailPayload)
                : await updateCreditCardTransactionDetail(creditCardDetailPayload);

            anySaved = anySaved || success;
            anyFailed = anyFailed || !success;
        }

        if (anySaved) {
            getCreditCardTransactions();
        }

        if (anySaved || anyFailed) {
            showToast(
                anyFailed ? 'Unable to save one or more credit card transaction details.' : 'Credit card transaction details saved successfully.',
                anyFailed ? `rgba(255,0,0,0.5)` : undefined
            );
        }
    };

    const closeCreditCardTransaction = async () => {
        const selectedTransaction = creditCardTransactions?.[selectedCreditCardTransactionIndex];

        if (!selectedTransaction) {
            window.alert('No credit transaction to close.. please find or create transaction first before trying to close...');
            return;
        }

        if (!!selectedTransaction.closeDate) {
            window.alert('This credit card transaction has already been closed...');
            return;
        }

        const detailTotal = calculateTotal();
        const invoiceAmount = Number(selectedTransaction.invoiceAmount) || 0;

        if (Math.round(detailTotal * 100) !== Math.round(invoiceAmount * 100)) {
            window.alert('Credit Card detail amount and invoice amount must match before this credit card transaction may be closed.');
            return;
        }

        await updateCreditCardRecord({
            ...selectedTransaction,
            closeDate: new Date(),
        });
    };

/*     const getPersonnelEmployeePay = async () => {
        let data = await get(`v1.0/landmen/${2}/get-personnel-employeePay`);
        if (response.ok) {
            console.log('========> Received Employee Pay Info', data);
            setSelectedEmployeePay(data);
        } else {
            // window.alert('Unable to Retrieve Selected Personnel\'s Billing Information.');
            console.log(`I don\'t think we need this.`);
        }
    }; */

    const getAllChargeIndividuals = async () => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals`);

        if (response.ok) {
            setAllChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get all charge individual Data!');
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setBillingAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const getOfficeExpenseCodes = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/expensetypes`);

        if (response.ok) {
            setOfficeExpenseCodes(result);
        } else {
            console.log('Unable to get Office Expense Code Data!!!');
        }
    };

    const getBudgetCategories = async () => {
        let result = await get(`/v1.0/AccountsPayable/budget/categories`);

        if (response.ok) {
            setBudgetCategories(result);
        } else {
            console.log('Unable to get Budget Category Data!!!');
        }
    };

    const getBudgetSubcategories = async () => {
        let result = await get(`/v1.0/AccountsPayable/budget/subcategories`);

        if (response.ok) {
            setBudgetSubcategories(result);
        } else {
            console.log('Unable to get Budget Subcategory Data!!!');
        }
    };

    // const updateEmployeePay = async (data: EmployeePay) => {
    //     let result = await put(`/v1.0/landmen/${2}/save-personnel-employeePay`, data);
    //     if (response.ok) {
    //         getPersonnelEmployeePay();
    //         window.alert('Update successful');
    //     } else if (result?.messageCode === '15') {
    //         window.alert('Update failed');
    //     } else {
    //         window.alert('Update failed');
    //     }
    // };

    const displayTitle = () => {
        const title = 'Transactions';

        return title;
    };

    const displayAccountInfo = () => {
        if (!!creditCardTransactionAccountInfo) {
            return (
                <div style={{ width: '100%' }}>
                    <div className="form-row" style={{ width: '100%' }}>
                        <RHFInputBox
                            label="Client"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`client`}
                            type="text"
                            defaultVal={creditCardTransactionAccountInfo.clientName}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '32%' }}
                        />
                        <RHFInputBox
                            label="Number"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`clientNumber`}
                            type="number"
                            defaultVal={!!creditCardTransactionAccountInfo.clientNumber ? `${creditCardTransactionAccountInfo.clientNumber}` : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '18%' }}
                        />
                        <RHFInputBox
                            label="Project"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`prospect`}
                            type="text"
                            defaultVal={creditCardTransactionAccountInfo.projectName}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '32%' }}
                        />
                        <RHFInputBox
                            label="Number"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`projectNumber`}
                            type="number"
                            defaultVal={!!creditCardTransactionAccountInfo.projectNumber ? `${creditCardTransactionAccountInfo.projectNumber}` : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '18%' }}
                        />
                    </div>
                    <div className="form-row" style={{ width: '100%' }}>
                        <RHFInputBox
                            label="Subcode"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`section`}
                            type="text"
                            defaultVal={!!creditCardTransactionAccountInfo.sectionName ? creditCardTransactionAccountInfo.sectionName : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '32%' }}
                        />
                        <RHFInputBox
                            label="Number"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`sectionNumber`}
                            type="number"
                            defaultVal={!!creditCardTransactionAccountInfo.sectionNumber ? `${creditCardTransactionAccountInfo.sectionNumber}` : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '18%' }}
                        />
                        <RHFInputBox
                            label="Alt Subcode"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`unit`}
                            type="text"
                            defaultVal={!!creditCardTransactionAccountInfo.unitName ? creditCardTransactionAccountInfo.unitName : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '32%' }}
                        />
                        <RHFInputBox
                            label="Number"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`unitNumber`}
                            type="number"
                            defaultVal={!!creditCardTransactionAccountInfo.unitNumber ? `${creditCardTransactionAccountInfo.unitNumber}` : ''}
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '18%' }}
                        />
                    </div>
                    <div className="form-row" style={{ width: '100%' }}>
                        <RHFInputBox
                            label="Billing Account"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`billingAccount`}
                            type="text"
                            defaultVal={creditCardTransactionAccountInfo.billingAccount}
                            register={register}
                            errors={errors}
                            style={{ width: '100%', height: '2.5rem' }}
                            bodyStyle={{ width: '35%' }}
                        />
                        <RHFInputBox
                            label="General Ledger Account"
                            labelStyle={{ whiteSpace: 'nowrap' }}
                            name={`glAccount`}
                            type="text"
                            defaultVal={creditCardTransactionAccountInfo.glAccount}
                            register={register}
                            errors={errors}
                            style={{ width: '100%', height: '2.5rem' }}
                            bodyStyle={{ width: '65%' }}
                        />
                    </div>
                </div>
            );
        } else {
            return (<>'No Credit Card Transaction Account Info'</>);
        }
    };

    const getNextTransactionSequenceId = () => {
        let maxId = 1;
        if (creditCardTransactionDetail?.length < 1) {
            return maxId;
        } else {
            maxId = creditCardTransactionDetail[0].id;
            for (const ccd of creditCardTransactionDetail) {
              if (ccd.id > maxId) {
                maxId = ccd.id;
              }
            }
        }
        return -(maxId + 1);
    };

    const insertBlankRow = () => {
        let newBlankRow = new CreditCardTransactionDetail();
        newBlankRow.clientNumber = (creditCardTransactionDetail?.length > 0 ? creditCardTransactionDetail[0]?.clientNumber : 90);
        newBlankRow.projectNumber = (creditCardTransactionDetail?.length > 0 ? creditCardTransactionDetail[0]?.projectNumber : 1);
        newBlankRow.billingAccount = '1';
        newBlankRow.expenseCode = 'O';
        newBlankRow.id = getNextTransactionSequenceId();

        // New rows go at the top - the list is sorted newest-first, and onSubmit's own save logic
        // (isNewRow ? transactionId : detailRow.transactionItemId) sets the real transactionItemId
        // at save time regardless of position, so there's no placeholder value to seed here.
        let updatedCCTransactionList = [newBlankRow, ..._.cloneDeep(creditCardTransactionDetail)];
        setCreditCardTransactionDetail(updatedCCTransactionList);
        setUnsavedTransactionDetails(true);
    };

    const displayChargeIndividuals = () => {
        if (chargeIndividuals.length) {       
            return <div>
              <table>
                  <thead>
                          <tr>
                              <th style={{ width: '20%' }}>Type</th>
                              <th style={{ width: '12%' }}>Client No.</th>
                              <th style={{ width: '28%' }}>Client/Company Name</th>
                              <th style={{ width: '10%' }}>Id No.</th>
                              <th style={{ width: '30%' }}>Name</th>
                          </tr>
                  </thead>
                  {chargeIndividuals?.map((x: ChargeIndividual, index: number) => {
                      return (
                          <tbody key={x.lmNo}>
                              <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                  <td style={{ width: '20%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].personType`}
                                          type="text"
                                          defaultVal={x.personType}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '10%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].clientNumber`}
                                          type="text"
                                          defaultVal={`${x.clientNumber}`}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '30%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].clientName`}
                                          type="text"
                                          defaultVal={x.clientName}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '10%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].lmNo`}
                                          type="text"
                                          defaultVal={x.lmNo + ''}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '30%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].firstName` + `creditCardRecForm.chargeIndividual[${index}].lastName`}
                                          type="text"
                                          defaultVal={x.firstName + ' ' + x.lastName}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                      <td style={{ width: '5%' }}>
                                          <Button 
                                              className="blue-hover-button" 
                                              reactIcon={IoMdCloseCircleOutline} 
                                              iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                              iconHoverColor="red"
                                              title="Remove Charge Individual"
                                              style={{ height: '3rem', background: 'transparent' }} 
                                              onClick={() => displayWarning(index)}
                                          />
                                      </td>
                              </tr>
                          </tbody>
                      );
                  })}
              </table>
          </div>;
          } else {
              return <div className="bold-centered">No Charge Individuals</div>;
          }
    };

    const displayCreditCardTransactions = () => {
        if (expenses?.length) {
            return <div style={{fontSize: '9px'}}>
                {!loadingCreditCardTransactionDetail &&
                 <table style={{ width: '100%' }}>
                    <thead>
                        <tr style={{height: '4rem'}}>
                            <th>Tran No.</th>
                            <th>Charge Date</th>
                            <th>Charge Amount</th>
                            <th>Charged By</th>
                            <th>Emp. Name</th>
                            <th>Description</th>
                            <th>Statement Description</th>
                            <th>G/L Account Number</th>
                            <th>Client </th>
                            <th>Project</th>
                            <th>Subcode</th>
                            <th>Alt Subcode</th>
                            <th>Billing Account</th>
                            <th>Expense Type</th>
                            <th>Budget Category</th>
                            <th>Budget Subcategory</th>
                        </tr>
                    </thead>
                    {!loadingCreditCardTransactionDetail && creditCardTransactionDetail?.map((x: CreditCardTransactionDetail, index: number) => {
                        // The subcategory list is filtered to the selected category. Once the user
                        // changes the category select, selectedBudgetCategoryByRow takes over; until
                        // then, derive it from the row's already-saved subcategory (bcdId).
                        const initialBudgetCategoryId = budgetSubcategories.find((bs) => bs.id === x.bcdId)?.categoryId;
                        const currentBudgetCategoryId = selectedBudgetCategoryByRow[x.id] ?? (initialBudgetCategoryId !== undefined ? `${initialBudgetCategoryId}` : undefined);

                        // Required-field validation only applies to a row the user is actually
                        // touching (new, or dirty) - handleSubmit blocks the WHOLE form's submit on
                        // any registered field's validation failure, so applying it unconditionally
                        // to every rendered row would let a blank legacy field on some untouched row
                        // block saving an edit on a completely different row.
                        const requireRowFields = x.id < 0 || !!dirtyFields?.creditCardRecForm?.creditCardDetails?.[index];

                        return (
                            <tbody key={x.id}>
                                <tr
                                    onDoubleClick={() => insertBlankRow()}
                                    onClick={() => getChargeIndividualsForSelectedCcTransaction(index)}
                                    className="table-item-hover"
                                    style={{ textAlign: 'center' }}
                                >
                                <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].ccTransactionNumber`}
                                            type="number"
                                            defaultVal={x.id + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                            readOnly={true}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargeDate`}
                                            type="date"
                                            defaultVal={formatDateForInput(x.chargeDate)}
                                            register={register}
                                            errors={errors}
                                            rules={requireRowFields ? { required: 'Charge date required' } : undefined}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargeAmount`}
                                            type="number"
                                            defaultVal={!!x?.chargeAmount ? x.chargeAmount.toFixed(2) + '' : ''}
                                            register={register}
                                            errors={errors}
                                            rules={requireRowFields ? { required: 'Amount required' } : undefined}
                                            style={{ width: '100%', textAlign: 'right' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargedBy`}
                                            type="number"
                                            defaultVal={x.chargedById + ''}
                                            register={register}
                                            errors={errors}
                                            rules={requireRowFields ? { required: 'Charged by required' } : undefined}
                                            style={{ width: '100%', background: '#d5f7f5' }}
                                            bodyStyle={{ width: '100%' }}
                                            onDoubleClick={() => findTsdiEmployee(x, index)}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].employeeName`}
                                            type="text"
                                            defaultVal={x.chargedByName}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].description`}
                                            type="text"
                                            defaultVal={x.description}
                                            register={register}
                                            errors={errors}
                                            rules={requireRowFields ? { required: 'Description required' } : undefined}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].statementDescription`}
                                            type="text"
                                            defaultVal={x.statementDescription}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <GLAccountSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].glAccountNumber`}
                                            defaultAccountNumber={x.glAccountNumber}
                                            register={register}
                                            errors={errors}
                                            setValue={setValue}
                                            onAccountNumberChange={(accountNumber) => setEditedGlAccountNumbers((current) => ({ ...current, [x.id]: accountNumber }))}
                                            style={{ width: '100%', background: '#d5f7f5', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.clientNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.projectNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.sectionNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.unitNumber}
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].billingAccount`}
                                            defaultVal={getCodeForBillingAccount(x.billingAccount)}
                                            options={billingAccounts?.map(ba => {
                                                return { value: ba.code, label: ba.description };
                                            })}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].expenseType`}
                                            defaultVal={getCodeForExpenseType(x.expenseCode)}
                                            options={officeExpenseCodes?.map(oec => {
                                                return { value: oec.code, label: oec.description };
                                            })}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].budgetCategoryId`}
                                            defaultVal={initialBudgetCategoryId}
                                            options={budgetCategories?.map((bc) => {
                                                return { value: bc.id, label: bc.name };
                                            })}
                                            register={register}
                                            errors={errors}
                                            onChange={(e) => {
                                                // React 16 pools/nullifies SyntheticEvents after the handler returns
                                                // synchronously - read currentTarget.value into a local now, since the
                                                // setState updater below can run after e has already been recycled.
                                                const selectedCategoryId = e.currentTarget.value;
                                                setSelectedBudgetCategoryByRow((current) => ({ ...current, [x.id]: selectedCategoryId }));
                                            }}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].bcdId`}
                                            defaultVal={x.bcdId}
                                            options={budgetSubcategories
                                                ?.filter((bs) => currentBudgetCategoryId !== undefined && `${bs.categoryId}` === currentBudgetCategoryId)
                                                .map((bs) => {
                                                    return { value: bs.id, label: bs.name };
                                                })}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </table>}
            </div>;
        } else {
            return <div className="bold-centered">No Charge Individuals</div>;
        }
    };

    const displayTotal = () => {
        return <div className="form-row" style={{marginLeft: '5%'}}>
            <RHFInputBox
                label="Total"
                labelOnLeft={true}
                name={`total`}
                type="text"
                // defaultVal={bill.classification}
                register={register}
                errors={errors}
                style={{ width: '100%', border: '2px solid black', textAlign: 'right' }}
                bodyStyle={{ width: '18rem' }}
            />
        </div>;
    };

    const moveToLastRecord = () => {
        clearForm(false);
        let nextIndex = creditCardTransactions?.length - 1;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const moveToFirstRecord = () => {
        let nextIndex = 0;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const nextTransaction = () => {
        clearForm(false);
        let nextIndex = selectedCreditCardTransactionIndex + 1 < creditCardTransactions?.length ? selectedCreditCardTransactionIndex + 1 : selectedCreditCardTransactionIndex;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const previousTransaction = () => {
        clearForm(false);
        let previousIndex = selectedCreditCardTransactionIndex - 1 >= 0 ? selectedCreditCardTransactionIndex - 1 : selectedCreditCardTransactionIndex;
        setSelectedCreditCardTransactionIndex(previousIndex);
        getCreditCardTransactionDetails(creditCardTransactions[previousIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[previousIndex]?.transactionNumber);
    };

    // Keep refs in sync so the debounced jump function below always reads current values
    // without needing to be re-created (and losing its pending debounce) on every navigation.
    const creditCardTransactionsRef = useRef(creditCardTransactions);
    const selectedCreditCardTransactionIndexRef = useRef(selectedCreditCardTransactionIndex);
    useEffect(() => {
        creditCardTransactionsRef.current = creditCardTransactions;
    }, [creditCardTransactions]);
    useEffect(() => {
        selectedCreditCardTransactionIndexRef.current = selectedCreditCardTransactionIndex;
    }, [selectedCreditCardTransactionIndex]);

    // Keep the displayed record number in sync whenever the selected record changes via
    // Next/Previous/First/Last/Search, not just via typing in the jump-to-record box.
    useEffect(() => {
        setRecordNumberInput(!!creditCardTransactions && creditCardTransactions.length > 0 ? `${selectedCreditCardTransactionIndex + 1}` : '');
        setRecordNumberError('');
    }, [selectedCreditCardTransactionIndex, creditCardTransactions]);

    const validateAndJumpToRecordNumber = useRef(_.debounce((rawValue: string) => {
        const trimmed = rawValue.trim();

        if (!trimmed) {
            setRecordNumberError('');
            return;
        }

        if (!/^\d+$/.test(trimmed)) {
            setRecordNumberError('Record # must be a whole number.');
            return;
        }

        const transactions = creditCardTransactionsRef.current;

        if (!transactions || transactions.length === 0) {
            setRecordNumberError('No transactions are loaded.');
            return;
        }

        const enteredNumber = parseInt(trimmed, 10);

        if (enteredNumber < 1 || enteredNumber > transactions.length) {
            setRecordNumberError(`Record # must be between 1 and ${transactions.length}.`);
            return;
        }

        setRecordNumberError('');

        const targetIndex = enteredNumber - 1;
        if (targetIndex !== selectedCreditCardTransactionIndexRef.current) {
            clearForm(false);
            setSelectedCreditCardTransactionIndex(targetIndex);
            getCreditCardTransactionDetails(transactions[targetIndex]?.transactionNumber);
            getCreditCardTransactionAccountInfo(transactions[targetIndex]?.transactionNumber);
        }
    }, 800)).current;

    const handleRecordNumberInputChange = (event: React.FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setRecordNumberInput(value);
        validateAndJumpToRecordNumber(value);
    };

    const findPerson = () => {
        console.log('Add Person Button Clicked');
        showDialog(DialogList.FIND_PERSON);
    };

    const runCreditCardSearch = async (criteria: ICreditCardTransactionSearchCriteria) => {
        setSearchingCreditCardTransactions(true);
        setNoTransactionsFound(false);
        try {
            const searchOptions = new ODataOptions();

            if (criteria.transactionNumber !== undefined) {
                searchOptions.addFilter(new ODataFilter('CC_ID', ODataFilterOperators.Equals, criteria.transactionNumber));
            }
            if (criteria.creditCardType !== undefined) {
                searchOptions.addFilter(new ODataFilter('CC_NO', ODataFilterOperators.Equals, criteria.creditCardType));
            }
            if (criteria.checkNumber !== undefined) {
                searchOptions.addFilter(new ODataFilter('CHECK_NO', ODataFilterOperators.Equals, criteria.checkNumber));
            }
            if (criteria.invoiceAmount !== undefined) {
                if (criteria.invoiceAmountLike) {
                    searchOptions.addFilter(new ODataFilter('CAST(INV_AMT AS VARCHAR(50))', ODataFilterOperators.Contains, encodeURIComponent(`%${criteria.invoiceAmount}%`)));
                } else {
                    searchOptions.addFilter(new ODataFilter('INV_AMT', ODataFilterOperators.Equals, criteria.invoiceAmount));
                }
            }
            if (criteria.checkDate) {
                searchOptions.addFilter(new ODataFilter('CHECK_DATE', ODataFilterOperators.Equals, criteria.checkDate.toISOString().split('T')[0]));
            }
            if (criteria.closeDate) {
                searchOptions.addFilter(new ODataFilter('CLOSE_DATE', ODataFilterOperators.Equals, criteria.closeDate.toISOString().split('T')[0]));
            }
            if (criteria.invoiceDate) {
                searchOptions.addFilter(new ODataFilter('INV_DATE', ODataFilterOperators.Equals, criteria.invoiceDate.toISOString().split('T')[0]));
            }

            searchOptions.addOrderBy('CCD_ID', ODataOrderByDirection.Ascending);

            const queryString = searchOptions.toString();
            let result = await get(`/v1.0/AccountsPayable/creditcards/transactions${queryString}`);

            if (!response.ok) {
                console.log('Unable to get CC transaction Data!');
                return;
            }

            if (!result?.items?.length) {
                setNoTransactionsFound(true);
                console.log('No Credit Card Transaction matched the given search criteria!');
                return;
            }

            setNoTransactionsFound(false);
            clearForm(false);
            setSelectedCreditCardTransactionIndex(0);
            setCreditCardTransactions(result.items);
        } finally {
            setSearchingCreditCardTransactions(false);
        }
    };

    // Mirrors Oracle Forms' post-Convert_Statement navigation: Set_Block_Property(..., 'cc_id = ...')
    // then Query_Block('Credit_Card_Master') - load the newly-created transaction into this screen.
    const handleStatementConverted = (creditCardId: number) => {
        runCreditCardSearch({ transactionNumber: creditCardId });
    };

    const upload = async (formData: FormData) => {
        await post(
            `/v1.0/AccountsPayable/creditcard/transactions/upload`,
            formData
        );
    };

    const prepareCsvFileForUpload = (formData: FormData) => {
        upload(formData);
    };

    const getCodeForBillingAccount = (billingAccount: string) => {
        if (!!billingAccounts) {
            const billingCode = billingAccounts.find((ba) =>
                                    ba.description === billingAccount
                                )?.code;
            if (!!billingCode) {
                return billingCode;
            } else {
                return 1;
            }
        }
        return 1;
    };

/*     const getCreditCardFromId = (ccId: number) => {
        if (!!creditCardTypes) {
            const ccName = creditCardTypes.find((cct) =>
                                    cct.id === ccId
                                )?.name;
            if (!!ccName) {
                return ccName;
            } else {
                return 'Chase Southwest';
            }
        }
        return 1;
    }; */

    const getCodeForExpenseType = (expenseType: string) => {
        if (!!officeExpenseCodes) {
            const expenseCode = officeExpenseCodes.find((oec) =>
                                    oec.description === expenseType
                                )?.code;
            if (!!expenseCode) {
                return expenseCode;
            } else {
                return 'O';
            }
        }
        return 'O';
    };

    const clearForm = (resetForm: boolean) => {
        setValue(`transactionNumber`, '');
        if (resetForm) {
            reset({
                ...new CreditCardTransaction(),
                checkDate: formatDateForInput(new Date()),
                closeDate: formatDateForInput(new Date()),
                invoiceDate: formatDateForInput(new Date()),
            });
            setCreditCardTransactions([]);
        }
        setCreditCardTransactionDetail([]);
        setCreditCardTransactionAccountInfo(undefined);
    };

    // Prepends a new blank transaction to the currently-loaded list (newest-first, same as the
    // detail rows) rather than wiping it like clearForm(true) used to - mirrors the load-search-
    // results pattern (clearForm(false) + select index 0 + setCreditCardTransactions) so the
    // existing [creditCardTransactions] effect fetches (and, finding none, seeds blank) detail rows
    // for the new record, which in turn triggers the form-reset effect to show its blank fields.
    const addCreditCardTransactionRecord = () => {
        clearForm(false);
        setSelectedCreditCardTransactionIndex(0);
        setCreditCardTransactions([new CreditCardTransaction(), ...(creditCardTransactions ?? [])]);
    };

/*     const setDropdownValue = (ev: React.FormEvent<HTMLSelectElement>, currentValue: string) => {
        const previousValue = getValues('creditCardType');
        const element = document.getElementById('!creditCardType!') as HTMLSelectElement;
        if (element.value !== previousValue && element.value !== currentValue) {
            element.value = previousValue;
        }
        // ev.currentTarget.value = ev.currentTarget.value != previousValue
    }; */

    const downloadCreditCardReceiptFile = async (receipt: VoucherReceipt) => {
        let result = await getBinary(`/AccountsPayable/receipts/creditcards/${receipt.id}/file`);

        if (responseBinary.ok && result?.byteLength > 0) {
            const fileBytes: Uint8Array = result;
            const blob = new Blob([fileBytes]);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = receipt.fileName || 'receipt';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        } else {
            console.log('Unable to get credit card receipt file!');
        }
    };

    const displayLegacyCreditCardReceipts = () => {
        return <div>
            <table>
                <thead>
                    <tr style={{ textAlign: 'left' }}>
                        <th>File Name</th>
                        <th>Description</th>
                        <th>File Date</th>
                        <th>File Type</th>
                        <th>File Size</th>
                    </tr>
                </thead>
                {creditCardReceipts?.map((x: VoucherReceipt, index: number) => {
                    return (
                        <tbody key={x.id}>
                            <tr
                                className="table-item-hover"
                                style={{ textAlign: 'center' }}
                                title="Double-click to download"
                                onDoubleClick={() => downloadCreditCardReceiptFile(x)}
                            >
                                <td style={{ width: '20%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileName`}
                                        type="text"
                                        defaultVal={x.fileName}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].description`}
                                        type="text"
                                        defaultVal={x.description}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileDate`}
                                        type="text"
                                        defaultVal={x.fileDate.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileType`}
                                        type="text"
                                        defaultVal={x.fileType}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileSize`}
                                        type="text"
                                        defaultVal={x.fileSize.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    const selectedCreditCardTransaction = creditCardTransactions?.[selectedCreditCardTransactionIndex];
    const isCreditCardTransactionClosed = !!selectedCreditCardTransaction?.closeDate;

    return (
        <div>
            {toast && (
                <PersonnelToast
                    message={toast.message}
                    color={toast.color}
                    persistent={toast.persistent}
                    onClose={() => setToast(null)}
                />
            )}
            <APNavBar/>
            <CreditCardSearch
                creditCardTypes={creditCardTypes}
                runQuery={runCreditCardSearch}
            />
            <form id="creditCardTransaction" onSubmit={handleSubmit(onSubmit)}>
                <Page className="dlc-maxer-width">
                    <Page.Section width={8}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={displayTitle()}>
                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row" style={{ marginBottom: '0', justifyContent: 'center' }}>
                                        {/* <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Void an AP Voucher"
                                            reactIcon={MdDoNotDisturb}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        /> */}
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reports"
                                            reactIcon={VscGraph}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                            onClick={() => reportOptions()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Add Credit Card Transaction"
                                            reactIcon={BiReceipt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                            onClick={() => addCreditCardTransactionRecord()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to First Record"
                                            reactIcon={BiArrowToLeft}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={moveToFirstRecord}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Previous Record"
                                            reactIcon={BiLeftArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={previousTransaction}
                                        />
                                        <input
                                            id="recordNumberInput"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={3}
                                            value={recordNumberInput}
                                            onChange={(e) => handleRecordNumberInputChange(e)}
                                            title="Enter a record # to jump to it"
                                            style={{
                                                fontWeight: 'bold',
                                                marginLeft: '1rem',
                                                width: '3rem',
                                                textAlign: 'center',
                                                border: recordNumberError ? '2px solid red' : '1px solid #ccc',
                                                borderRadius: '4px',
                                                outline: 'none'
                                            }}
                                        />
                                        <label style={{marginLeft: '.5rem', marginRight: '.5rem'}}>of</label>
                                        <label style={{fontWeight: 'bold'}}>{creditCardTransactions?.length ?? 0}</label>
                                        {recordNumberError &&
                                            <label style={{marginLeft: '1rem', color: 'red', fontWeight: 'bold', whiteSpace: 'nowrap'}}>
                                                {recordNumberError}
                                            </label>}
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title={isCreditCardTransactionClosed ? 'Closed transactions cannot be changed.' : 'Save Changes'}
                                            reactIcon={FaRegSave}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            type={'submit'}
                                            disabled={isCreditCardTransactionClosed}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Next Record"
                                            reactIcon={BiRightArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={nextTransaction}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Last Record"
                                            reactIcon={BiArrowToRight}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => moveToLastRecord()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Prepare Multiple Checks"
                                            reactIcon={FaMoneyCheckAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => chooseVouchers()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Write Check for CC Charges"
                                            reactIcon={GiQuillInk}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => writeCheck()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reprint Check for Invoice"
                                            reactIcon={FaPrint}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => window.print()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Access Credit Card Statement Maintenance"
                                            reactIcon={FaCreditCard}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => accessCreditCardStatement()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title={isCreditCardTransactionClosed ? 'Closed' : 'Close CC Record'}
                                            reactIcon={isCreditCardTransactionClosed ? FaLock : FaLockOpen}
                                            iconHoverColor="blue"
                                            iconStyle={{fill: isCreditCardTransactionClosed ? 'red' : 'green', width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                                            disabled={isCreditCardTransactionClosed}
                                            onClick={() => closeCreditCardTransaction()}
                                        />
                                        {isCreditCardTransactionClosed &&
                                            <label
                                                style={{
                                                    marginLeft: '1rem', borderRadius: '5px', padding: '3px', fontSize: '14px', fontWeight: 'bold',
                                                    backgroundColor: 'red', color: '#f8c3c3', whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Closed on {moment(selectedCreditCardTransaction.closeDate).format('MM/DD/YYYY')}
                                            </label>
                                        }
                                        {!isCreditCardTransactionClosed &&
                                            <label
                                                style={{
                                                    marginLeft: '1rem', borderRadius: '5px', padding: '3px', fontSize: '14px', fontWeight: 'bold',
                                                    backgroundColor: 'green', color: '#b2fab6', whiteSpace: 'nowrap'
                                                }}
                                            >
                                                OPEN
                                            </label>
                                        }
                                    </div>
                                    <div style={{ height: '5rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {searchingCreditCardTransactions &&
                                            <div style={{ transform: 'translateY(10px)' }}>
                                                <LoadingSpinner />
                                            </div>
                                        }
                                        {!searchingCreditCardTransactions && noTransactionsFound &&
                                            <div className="bold-centered">{NO_TRANSACTIONS_FOUND_MESSAGE}</div>
                                        }
                                    </div>
                                    <RHFInputBox
                                        name={`creditCardType`}
                                        type="hidden"
                                        defaultVal={!!creditCardTransactions &&
                                            creditCardTransactions.length > 0 ? `${creditCardTransactions[selectedCreditCardTransactionIndex]?.creditCardType}` : ''}
                                        register={register}
                                    />
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <div className="form-row" style={{ marginTop: '1rem', visibility: searchingCreditCardTransactions ? 'hidden' : 'visible' }}>
                                        <RHFInputBox
                                            label="Transaction Number"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`transactionNumber`}
                                            type="number"
                                            defaultVal={!!creditCardTransactions &&  creditCardTransactions?.length > 0 ?
                                                creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber + '' : '0'}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '12%', marginLeft: '.5rem' }}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Credit Card"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`creditCardTypeName`}
                                            type="text"
                                            defaultVal={creditCardTypes?.find(c => `${c.id}` === `${creditCardTransactions?.[selectedCreditCardTransactionIndex]?.creditCardType}`)?.name
                                                ?? (!!creditCardTransactions && creditCardTransactions.length > 0 ?
                                                    `${creditCardTransactions[selectedCreditCardTransactionIndex]?.creditCardType}` : '')}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Invoice Amount"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`invoiceAmount`}
                                            type="number"
                                            register={register}
                                            defaultVal={!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.invoiceAmount + '' : '0'}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '14%'}}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Check No."
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`checkNumber`}
                                            type="number"
                                            defaultVal={!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.checkNumber + '' : '0'}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '12%'}}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Check Date"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`checkDate`}
                                            type="date"
                                            defaultVal={formatDateForInput(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.checkDate : new Date())}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '14%' }}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Invoice Date"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`invoiceDate`}
                                            type="date"
                                            defaultVal={formatDateForInput(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.invoiceDate : new Date())}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '14%' }}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Close Date"
                                            labelStyle={{ whiteSpace: 'nowrap' }}
                                            name={`closeDate`}
                                            type="date"
                                            defaultVal={formatDateForInput(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.closeDate : new Date())}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '14%' }}
                                            readOnly={true}
                                        />
                                    </div>
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={4}>
                        <Panel backgroundColor="#D3D3D3" height="100%">
                            <Panel panelTitle="Account Information" height="100%">
                                <div style={{ flex: 1, minHeight: 0, padding: '.5rem', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ overflowY: 'auto', flex: 1, minHeight: 0 }}>
                                        {creditCardTransactionAccountInfo && displayAccountInfo()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="Transaction Details">
                                <div className="form-row" style={{ marginBottom: '0' }}>
                                    {loadingCreditCardTransactionDetail &&
                                        <div style={{alignContent: 'center', width: '100%'}}>
                                            <LoadingSpinner />
                                        </div>
                                    }
                                    <div style={{ textAlign: 'center', width: '100%' }}>
                                        <div style={{ maxHeight: '25rem', overflowY: 'auto', width: '100%' }}>
                                            {displayCreditCardTransactions()}
                                        </div>
                                        <hr style={{margin: '1rem 0'}}/>
                                        {displayTotal()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={'A/P CC Receipts'}>
                                <div>
                                    <div className="tiny-panel" style={{ overflowY: 'scroll' }}>
                                        <ReceiptDocs
                                            showDialog={showDialog}
                                            hideDialog={hideDialog}
                                            hasOwnership={false}
                                            userId={2}
                                            ccTransactionId={!!creditCardTransactionDetail && selectedCreditCardTransactionIndex !== 0 ?
                                                creditCardTransactionDetail[selectedCreditCardTransactionIndex]?.id : 0}
                                        />
                                    </div>
                                    <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                        {displayLegacyCreditCardReceipts()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={'Credit Card Charge Individuals'}>
                                <div className="tiny-panel" style={{textAlign: 'center', overflowY: 'scroll'}}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ height: '3rem', justifyContent: 'center'}}
                                        text={'Add Person'}
                                        onClick={() => findPerson()}
                                    />
                                    {chargeIndividuals && displayChargeIndividuals()}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
            </form>
            <FindPersonDialog 
                dialogName={DialogList.FIND_PERSON} 
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}                
                populatePersonList={getAllChargeIndividuals}
                personList={allChargeIndividuals}
            />
            <DefineBudgetCategoryDialog 
                dialogName={DialogList.DEFINE_BUDGET_CATEGORY} 
                hideDialog={hideDialog}
                handleCategories={handleCategories}
                selectedExpense={selectedExpense}
            />
            <WarningDialog 
                dialogName={DialogList.WARNING} 
                hideDialog={hideDialog}
                handleConfirm={handleConfirmRemovePerson}
            />
            <ReportOptionsDialog 
                dialogName={DialogList.REPORT_OPTIONS} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
            <ChooseVouchersDialog 
                dialogName={DialogList.CHOOSE_VOUCHERS_TO_PAY} 
                hideDialog={hideDialog}
                handleSelectedVouchers={handleSelectedVouchers}
            />
            <FindAvailableAccountsDialog 
                dialogName={DialogList.FIND_AVAILABLE_ACCOUNTS} 
                hideDialog={hideDialog}
                handleSelectedAccount={handleSelectedAccount}
            />
            <TSDIEmployeesDialog
                dialogName={DialogList.TSDI_EMPLOYEES} 
                hideDialog={hideDialog}
                handleSelectedEmployee={handleSelectedEmployee}
            />
            <CreditCardStatementDialog
                dialogName={DialogList.CREDIT_CARD_STATEMENT_MAINTENANCE}
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                creditCardTypes={creditCardTypes}
                onStatementConverted={handleStatementConverted}
                onRequestUpload={showLoadRawDataFileForStatement}
                refreshToken={statementListRefreshToken}
            />
            <LoadRawDataFileDialog
                dialogName={DialogList.LOAD_RAW_DATA_FILE}
                showDialog={showDialog}
                hideDialog={hideDialog}
                setFileToUpload={setFileToUpload}
                creditCardTypes={creditCardTypes}
            />
            <LoadRawDataFileDialog
                dialogName={DialogList.LOAD_RAW_DATA_FILE_FOR_STATEMENT}
                showDialog={showDialog}
                hideDialog={hideDialog}
                creditCardTypes={creditCardTypes}
                onUploaded={handleStatementFileUploaded}
            />
            <EnterCheckNumberDialog 
                dialogName={DialogList.ENTER_CHECK_NUMBER} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
            <CreateCheckWarningDialog 
                dialogName={DialogList.CREATE_CHECK_WARNING} 
                hideDialog={hideDialog}
                handleConfirm={handleConfirmCreateCheck}
                showDialog={showDialog}
            />
            <OutputDestinationDialog 
                dialogName={DialogList.OUTPUT_DESTINATION} 
                hideDialog={hideDialog}
                handleDownload={handleDownload}
            />
        </div>
    );
};

export default CreditCardsRecPage;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/CreditCardsRecPage.tsx